































import {Component, Vue} from "vue-property-decorator"
import {State} from "vuex-class"
import {logout} from "@/data/api/auth"

@Component
  export default class UserInfo extends Vue {
    @State("sso") public sso: any
    @State("appList") public appList: any
    @State("userInfo") public userInfo: any
    private showMenu: boolean = false

    public created() {
      !this.userInfo.userId && this.$store.dispatch("updateUserInfo")
      this.$store.dispatch("updateAppList")
    }

    public toggleMenu() {
      this.showMenu = !this.showMenu
    }

    public hideMenu() {
      this.showMenu = false
    }

    get myDetailsUrl() {
      if (!this.appList) {
        return ""
      }
      return `${this.appList.accountsApplicationUrl}/user?id=${this.userInfo.userId}&app=MAC&returnUrl=${encodeURIComponent(window.location.href)}`
    }

    public logout() {
      logout()
      console.log("Logged out")
    }
  }
